exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label[data-v-7b824eef]{display:inline;font-size:.8rem;text-align:left}.form-group[data-v-7b824eef]{margin-bottom:.9rem}#review_form .radio-inline[data-v-7b824eef]{font-weight:400;vertical-align:middle}#review_form .radio-inline input[data-v-7b824eef]{margin-top:.4rem}#date_of_visit[data-v-7b824eef],#review_form input[data-v-7b824eef],#review_form textarea[data-v-7b824eef]{margin-top:.1rem;font-size:.8rem}.select-box[data-v-7b824eef]{cursor:auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7b824eef","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddReview.vue
// module id = 136
// module chunks = 0